import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import gameSong from '../../asserts/music.mp3';
import clickSfx from '../../asserts/click.mp3';
import winSong from '../../asserts/Win.mp3';
import loseSong from '../../asserts/Lose.mp3';
import giftSong from '../../asserts/Gift.mp3';

const MusicContext = createContext();

export const MusicProvider = ({ children }) => {
  const audioRef = useRef(null);

  const [music, setMusic] = useState(() => {
    const saved = sessionStorage.getItem('music');
    return saved === null ? true : saved === 'true';
  });

  const [sfx, setSfx] = useState(() => {
    const saved = sessionStorage.getItem('sfx');
    return saved === null ? true : saved === 'true';
  });

  const sfxRef = useRef(sfx);
  const musicRef = useRef(music);
  const startedRef = useRef(false);
  const resultAudioRef = useRef(null);

  useEffect(() => { sfxRef.current = sfx; sessionStorage.setItem('sfx', sfx); }, [sfx]);
  useEffect(() => { musicRef.current = music; sessionStorage.setItem('music', music); }, [music]);

  useEffect(() => {
    audioRef.current = new Audio(gameSong);
    audioRef.current.loop = true;
    audioRef.current.volume = 0.35;

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
      if (resultAudioRef.current) {
        resultAudioRef.current.pause();
        resultAudioRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!audioRef.current || !startedRef.current) return;
    if (music) {
      audioRef.current.play().catch(() => {});
    } else {
      audioRef.current.pause();
    }
  }, [music]);

  const startBgMusic = () => {
    if (startedRef.current) return;
    startedRef.current = true;
    if (musicRef.current && audioRef.current) {
      audioRef.current.play().catch(() => {});
    }
  };

  const muteBgMusic = () => {
    if (audioRef.current) audioRef.current.volume = 0;
  };

  const unmuteBgMusic = () => {
    if (audioRef.current) audioRef.current.volume = 0.35;
  };

  const playClick = () => {
    if (!sfxRef.current) return;
    const click = new Audio(clickSfx);
    click.volume = 0.75;
    click.play().catch(() => {});
  };

  const playResultMusic = (type) => {
    if (audioRef.current) audioRef.current.pause();

    if (resultAudioRef.current) {
      resultAudioRef.current.pause();
      resultAudioRef.current = null;
    }

    if (!musicRef.current) return;

    const src = type === 'win' ? winSong : loseSong;
    const audio = new Audio(src);
    audio.volume = 0.5;
    audio.play().catch(() => {});
    resultAudioRef.current = audio;
  };

  const playGiftMusic = () => {
    if (audioRef.current) audioRef.current.pause();

    if (resultAudioRef.current) {
      resultAudioRef.current.pause();
      resultAudioRef.current = null;
    }

    if (!musicRef.current) return;

    const audio = new Audio(giftSong);
    audio.volume = 0.5;
    audio.play().catch(() => {});
    resultAudioRef.current = audio;
  };

  const stopResultMusic = () => {
    if (resultAudioRef.current) {
      resultAudioRef.current.pause();
      resultAudioRef.current = null;
    }

    if (musicRef.current && audioRef.current && startedRef.current) {
      audioRef.current.play().catch(() => {});
    }
  };

  return (
    <MusicContext.Provider value={{ music, setMusic, sfx, setSfx, playClick, muteBgMusic, unmuteBgMusic, startBgMusic, playResultMusic, playGiftMusic, stopResultMusic }}>
      {children}
    </MusicContext.Provider>
  );
};

export const useMusic = () => useContext(MusicContext);